import React, { ComponentProps } from 'react'

import { Box, SurglogsLoader } from '@surglogs-app/ui'

export const LogoComponentLoader = (props: ComponentProps<typeof Box>) => (
  <Box {...{ position: 'relative', w: '100%', h: '100%', ...props }}>
    <SurglogsLoader />
  </Box>
)
